// This module exists both to handle browsers that doesn't have `localStorage`
// and for private browsing in iOS which throws exceptions when you call `setItem`

let fauxStorage: { [key: string]: any } = {};

export function setLocalStorageItem(key: string, value: any) {
  try {
    // Undefined is not JSON, but null is
    if (value === undefined) {
      value = null;
    }
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    fauxStorage[key] = value;
    console.error('localStorage.setItem() failed:', e);
  }
}

export function getLocalStorageItem<T>(key: string, defaultValue?: T) {
  try {
    const value = localStorage.getItem(key);
    if (value === null || value === undefined || value === 'undefined') {
      return defaultValue;
    } else {
      return JSON.parse(value) as T;
    }
  } catch (e) {
    console.error('localStorage.getItem() failed:', e);
    if (!(key in fauxStorage)) {
      return defaultValue;
    }
    return fauxStorage[key] as T;
  }
}

export function nukeLocalStorage() {
  try {
    localStorage.clear();
  } catch (e) {
    console.error('localStorage.clear() failed:', e);
    fauxStorage = {};
  }
}
